export enum EcomServiceType {
  Drive = "DRIVE",
  HomeDelivery = "HOME_DELIVERY",
  HomeDeliveryNonAl = "HOME_DELIVERY_NON_AL",
  TwoHourPickup = "TWO_HOUR_PICKUP",
  ExpressDelivery = "EXPRESS_DELIVERY",
  Deliveroo = "DELIVEROO",
  UberEats = "UBER_EATS",
  Traiteur = "TRAITEUR",
  Macave = "MACAVE",
  Bringo = "BRINGO",
  PhotoImage = "PHOTO_IMAGE",
  EcomTotal = "ECOM_TOTAL",
}
